import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'
import {
  IconPickerConfig,
  IconStyles,
  IconTypes,
} from 'components/Customize/Styling/IconPicker/Constants'
import style from './style.styl'

const DISMISS_ICON = require('!svg-inline?removeTags=true&removeSVGTagAttrs=false!images/svg/dismiss.svg')

function getIconUrl(iconStyle, iconType) {
  switch (iconType) {
    case IconTypes.dismiss:
      return DISMISS_ICON
    default:
      return IconPickerConfig[iconStyle][iconType]
  }
}

const Widget = ({
  iconStyle = IconStyles.SOLID1,
  iconType = IconTypes.chatSrc,
  iconUrl,
  avatarUrl,
  backgroundColor,
  foregroundColor,
  unreadCount,
}) => {
  const url = avatarUrl || iconUrl

  if (url) {
    return (
      <div className={style.Widget}
           style={{
             backgroundImage: `url(${url})`,
             backgroundSize: "cover",
             backgroundPosition: "center",
             backgroundColor: `#${backgroundColor}`,
           }}>
        { unreadCount ? <div className={style.Widget__Count}>{unreadCount}</div> : undefined }
      </div>
    )
  }

  return (
    <div
      className={style.Widget}
      style={{ backgroundColor: `#${backgroundColor}`, color: `#${foregroundColor}`}}
    >
      <IconSVG
        className={cx({ [style[`icon-type-${iconType}`]]: iconType })}
        src={getIconUrl(iconStyle, iconType)}
      />
      { unreadCount ? <div className={style.Widget__Count}>{unreadCount}</div> : undefined }
    </div>
  )
}
Widget.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  foregroundColor: PropTypes.string.isRequired,
  iconStyle: PropTypes.oneOf(Object.keys(IconStyles)),
  iconType: PropTypes.oneOf(Object.keys(IconTypes)),
  iconUrl: PropTypes.string,
  avatarUrl: PropTypes.string,
}

export default Widget



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Preview/Widget/index.js